import React, { createContext, useState } from "react";

const NotificationContext = createContext(null);

const NotificationProvider = ({ children }) => {
	const [notifications, setNotifications] = useState([]);

	const removeNotification = (item) => {
		clearTimeout(item.timeoutId);

		// Use functional version of setNotifications to ensure we are using the latest state
		// since this method is likely called via setTimeout closed to a stale state.
		setNotifications((currentNotifications) => {
			let newNotifications = currentNotifications.map((obj) => ({ ...obj }));
			return newNotifications.filter((a) => a.timeoutId != item.timeoutId);
		});
	};

	const addNotification = (message, variant) => {
		const clonedNotifications = notifications.map((obj) => ({ ...obj }));
		const alert = { message, variant };
		alert.timeoutId = setTimeout(removeNotification, 5000, alert);
		alert.remove = removeNotification.bind(this, alert);
		clonedNotifications.push(alert);
		setNotifications(clonedNotifications);
	};

	const showInfoMessage = (message) => addNotification(message, 'info');
	const showErrorMessage = (message) => addNotification(message, 'error');
	const showWarningMessage = (message) => addNotification(message, 'warning');

	return (
		<NotificationContext value={{ notifications, showInfoMessage, showErrorMessage, showWarningMessage }}>
			{children}
		</NotificationContext>
	)
};

export { NotificationProvider, NotificationContext };